export default "__VITE_ASSET__Cx_hrxZJ__"